import * as React from "react";
import apiClients from "../../apiClients";
import * as Messages from "../../codegen/Messages";
import { parseId } from "../../helpers/idHelper";
import { useMutationCall } from "../../hooks/useMutationCall";
import {
  AsyncNotificationMethodKey,
  AsyncNotificationPolledResponseKey,
  MDS_DELETE_POLL_DELAY,
  MDS_DELETE_POLL_INTERVAL,
} from "../../models/AsyncNotificationProviders";
import { getOciRegion } from "../../utils";
import { OperationConfirmationProps } from "../OperationTypes";

export interface MysqlDeleteProps extends OperationConfirmationProps {
  databaseId: string | undefined;
}

const MysqlDelete = (
  { location, databaseId, onExecute }: MysqlDeleteProps,
): JSX.Element => {
  const { invokeCall: invokeMdsDelete } = useMutationCall(
    { method: apiClients.withRegion(getOciRegion(location)).mdsDatabaseApi.deleteMdsDbSystem },
  );

  React.useEffect(() => {
    const { subscriptionId, resourceGroup, resourceName } = parseId(databaseId);
    const resourceGroupName = decodeURIComponent(resourceGroup || "");
    const dbSystemName = decodeURIComponent(resourceName || "");

    const invokeOptions = {
      onSuccess: onExecute,
      notification: {
        inProgress: {
          title: Messages.notifications.inProgress.titles.deleteMysql(),
          message: Messages.notifications.inProgress.messages.deleteMysql(dbSystemName),
        },
        success: {
          title: Messages.notifications.success.titles.deleteMysql(),
          message: Messages.notifications.success.messages.deleteMysql(dbSystemName),
        },
        failure: {
          title: Messages.notifications.failure.titles.delete(),
          message: Messages.notifications.failure.messages.deleteMysql(dbSystemName),
        },
        asyncPolling: {
          methodKey: AsyncNotificationMethodKey.MDS_GET,
          methodArgs: {
            subscriptionId,
            resourceGroupName,
            dbSystemName,
          },
          location,
          errorStatusOverrides: [404],
          responseMethodKey: AsyncNotificationPolledResponseKey.MDS_DELETED_CHECK,
          delay: MDS_DELETE_POLL_DELAY,
          interval: MDS_DELETE_POLL_INTERVAL,
        },
      },
    };
    invokeMdsDelete({
      subscriptionId,
      resourceGroupName,
      dbSystemName,
    }, invokeOptions);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <div />;
};

export const newMysqlDelete = (
  props: MysqlDeleteProps,
): JSX.Element => (<MysqlDelete {...props} />);
